<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加展厅</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                label="图片"
                align="center"
                width="120">
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.img_url"
                    fit="cover"
                    style="width: 77px;height: 40px;"
                    :preview-src-list="[scope.row.img_url]">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="title"
                label="标题"
                width="180"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="desc"
                label="描述"
                min-width="140"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="designer"
                label="设计师"
                width="120"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="views"
                label="浏览量"
                width="120"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="uploadName"
                label="上传人"
                width="120"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="time"
                label="上传时间"
                width="160"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="操作"
                width="200"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-edit" size="mini" @click="editRow(scope.row)">修改</el-button>
                  <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="dialogVisible"
      width="800px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" size="small" :model="editForm" label-width="80px" style="padding:15px 30px 15px 15px;" :rules="rules">
        <el-form-item label="封面" prop="img">
          <span style="color:#99a9bf;font-size: 12px;"><i class="el-icon-info"></i> 图片建议尺寸690*360px</span>
          <SingleImg :key="imgKey" v-model="editForm.img" :oldurl="editForm.oldImg_url" :size="[345,180]"></SingleImg>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="editForm.title" maxlength="20" placeholder="请输入展厅标题" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="editForm.desc" maxlength="20" placeholder="请输入展厅描述" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="设计师" prop="designer">
          <el-input v-model="editForm.designer" maxlength="20" placeholder="请输入展厅设计师" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="浏览量" prop="views">
          <el-input-number v-model="editForm.views" :min="0" :max="999999" ></el-input-number>
        </el-form-item>
        <el-form-item label="展厅内容" prop="content">
          <tinymce ref="tinymce" :key="tinymcekey" v-model="editForm.content" :height="200" ></tinymce>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button :loading="eidtLoading" type="primary" @click="SubForm()">立即提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import SingleImg from '@/components/upload/SingleImg'
import Tinymce from '@/components/Tinymce/index'
import { selectShowHallDataXCX, editShowHall,deleteShowHall } from '@/api/zsxcx'
export default {
  name: 'ztlb',
  components: { SingleImg, Tinymce },
  computed: {
    user: getUser
  },
  data() {
    return {
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        search: ''
      },
      imgKey: '',
      tinymcekey: '',
      editTitle: '',
      dialogVisible: false,
      eidtLoading: false,
      editForm: {
        showid: null,
        img: null,
        oldImg_url: '',
        title: '',
        desc: '',
        designer: '',
        views: '',
        userid: '',
        time: '',
        content: ''
      },
      rules: {
        img: [{ required: true, message: '封面不能为空', trigger: 'change' }],
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        desc: [{ required: true, message: '描述不能为空', trigger: 'blur' }],
        designer: [{ required: true, message: '设计师不能为空', trigger: 'blur' }],
        views: [{ required: true, message: '浏览量不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '展厅内容不能为空', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.selectShowHallData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.selectShowHallData()
    },
    selectShowHallData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        search: this.searchForm.search
      }
      selectShowHallDataXCX(data).then(response => {
        this.tableData = response.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    editRow(row) {
      this.imgKey = new Date().getTime() + 2
      this.tinymcekey = new Date().getTime()
      if (row == null) {
        this.editTitle = '添加展厅信息'
        this.editForm.showid = null
        this.editForm.img = null
        this.editForm.oldImg_url = ''
        this.editForm.title = ''
        this.editForm.desc = ''
        this.editForm.designer = ''
        this.editForm.views = ''
        this.editForm.content = ''
        this.editForm.userid = this.user.dUserid
        if (this.$refs['tinymce'] !== undefined) {
          this.$refs['tinymce'].setContent('')
        }
      } else {
        this.editTitle = '编辑展厅信息'
        this.editForm.showid = row.showid
        this.editForm.img = { imgid: row.imgid, img_url: row.img_url }
        this.editForm.oldImg_url = row.img_url
        this.editForm.title = row.title
        this.editForm.desc = row.desc
        this.editForm.designer = row.designer
        this.editForm.views = row.views
        this.editForm.content = row.content
        this.editForm.userid = row.userid
        if (this.$refs['tinymce'] !== undefined) {
          this.$refs['tinymce'].setContent(row.content)
        }
      }
      this.dialogVisible = true
    },
    SubForm() {
      if (!this.eidtLoading) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.eidtLoading = true
            const data = {
              showid: this.editForm.showid,
              imgid: this.editForm.img.imgid,
              title: this.editForm.title,
              desc: this.editForm.desc,
              designer: this.editForm.designer,
              views: this.editForm.views,
              content: this.editForm.content,
              userid: this.editForm.userid
            }
            editShowHall(data).then(response => {
              this.eidtLoading = false
              this.dialogVisible = false
              this.selectShowHallData()
            }).catch(() => {
              this.eidtLoading = false
            })
          }
        })
      }
    },
    deleteRow(row) {
      this.$confirm('您确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        deleteShowHall({ showid: row.showid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.selectShowHallData()
        })
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
